import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { UserStoreService } from '../../../../shared/services/state-management/user-store.service';
import { Subscription } from 'rxjs';
import {
  UserService as SDKUserService,
  AuthenticationService as SDKAuthentication
} from '@adeo/ngx-kozikaza-api';
import { SigninFormLiteService } from './signin-form-lite.service';
import { ActivatedRoute } from '@angular/router';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsDiscover } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-discover.icon';

@Component({
  selector: 'app-signin-form-lite',
  templateUrl: './signin-form-lite.component.html',
  styleUrls: ['./signin-form-lite.component.scss']
})
export class SigninFormLiteComponent implements OnDestroy, OnInit {
  loginForm: UntypedFormGroup;
  wrongLogin = false;
  hasError = false;
  submitted = false;
  emailStarred: string;
  showPassword = false;
  public bannedAction = false;

  authenticatedSubscription: Subscription;
  codeParamsSubscription: Subscription;
  saveSubscription: Subscription;

  constructor(
    private readonly userStoreService: UserStoreService,
    private sdkAuthenticationService: SDKAuthentication,
    private sdkUserService: SDKUserService,
    private fb: UntypedFormBuilder,
    private signinFormLiteService: SigninFormLiteService,
    private activatedRoute: ActivatedRoute,
    private kzIconsRegistryService: KzIconsRegistryService,
    private cdr: ChangeDetectorRef,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsDiscover]);
    this.loginForm = this.fb.group({
      emailOrPhone: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.codeParamsSubscription = this.activatedRoute.queryParams.subscribe(
      (params) => {
        if (params.bannedAction !== null && params.bannedAction === 'true') {
          this.bannedAction = true;
        }

        if (params.email !== null) {
          this.loginForm.patchValue({
            emailOrPhone: params.email
          });
        }
      }
    );

    this.saveSubscription = this.signinFormLiteService.submitted.subscribe(
      (value) => {
        if (value) {
          this.submitted = true;
          this.save();
        } else {
          this.submitted = false;
        }
      }
    );
  }

  isFieldInvalid(name: string): boolean {
    if (!this.loginForm) {
      return false;
    }

    const control = this.loginForm.get(name);
    if (!control) {
      return false;
    }
    return (this.hasError || control.dirty || control.touched) && control.invalid;
  }

  save(): void {
    this.wrongLogin = false;

    if (this.loginForm.valid) {
      this.hasError = false;
      this.submitted = true;

      this.userStoreService.userActiveKaza = undefined;
      this.authenticatedSubscription = this.sdkAuthenticationService.authenticateUser({
        username: this.loginForm.get('emailOrPhone').value,
        password: this.loginForm.get('password').value
      })
        .pipe(
          finalize(() => {
            this.signinFormLiteService.submitted.next(false);
            this.cdr.markForCheck();
          })
        )
        .subscribe(
          () => {},
          () => {
            this.wrongLogin = true;
          }
        );
    } else {
      this.signinFormLiteService.submitted.next(false);
      this.hasError = true;
    }
  }

  checkValue(): void {
    // 2021 10 26 - KZ : not used
    // if (this.loginForm.get('emailOrPhone').value &&
    //   this.loginForm.get('emailOrPhone').value !== '' &&
    //   this.loginForm.get('emailOrPhone').value.indexOf('@') === -1
    // ) {
    //   this.getStarredEmail(this.loginForm.get('emailOrPhone').value);
    // }
  }

  ngOnDestroy() {
    if (this.authenticatedSubscription && !this.authenticatedSubscription.closed) {
      this.authenticatedSubscription.unsubscribe();
    }
    if (this.codeParamsSubscription && !this.codeParamsSubscription.closed) {
      this.codeParamsSubscription.unsubscribe();
    }
    if (this.saveSubscription && !this.saveSubscription.closed) {
      this.saveSubscription.unsubscribe();
    }
  }
}
